import React, { ChangeEvent, useState } from "react";
import { Button } from '@material-ui/core'

import Popup from "components/Popup";
import MaterialInput from "components/Inputs/MaterialInput";

import {
    PopupContainer,
    PopupTitle,
    PopupDescription,
    StyledFormHelperText,
    InputContainer
} from "../common.styles";

const EMAIL_VALIDATION_REGEX = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

interface EmailConfirmationPopupProps {
    opened: boolean,
    emailValue: string,
    onClose: () => void,
    onSave: (value: string) => void
}

const EmailConfirmationPopup = ({opened, emailValue, onClose, onSave}: EmailConfirmationPopupProps) => {
    const [editedEmail, setEditedEmail] = useState(emailValue)
    const [editedEmailError, setEditedEmailError] = useState('')

    const onEditedEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newEmail = event.target.value;

        setEditedEmail(newEmail);
        setEditedEmailError(!EMAIL_VALIDATION_REGEX.test(newEmail) ? 'Please enter a valid email.' : '')
    }

    return (
        <Popup opened={opened} onClose={onClose}>
            <PopupContainer>
                <PopupTitle>Almost done!</PopupTitle>
                <PopupDescription>We’ll send email notifications about this job to the address below. You can change this later in your profile settings.</PopupDescription>
                <InputContainer>
                    <MaterialInput
                        type="text"
                        id="email"
                        name="email"
                        label="Email"
                        error={!!editedEmailError}
                        inputProps={{
                            value: editedEmail,
                            onChange: onEditedEmailChange,
                        }}
                    />
                    {editedEmailError ? <StyledFormHelperText>{editedEmailError}</StyledFormHelperText> : null}
                </InputContainer>
                <Button
                    variant="contained"
                    onClick={() => onSave(editedEmail)}
                    color="primary"
                    disabled={!!editedEmailError}
                    size="large"
                    id="review-button"
                    className="bigButtonInNewStyle"
                >
                    OK
                </Button>
            </PopupContainer>
        </Popup>
    );
}

export default EmailConfirmationPopup
